import { APP_ROUTES, OTP_LOGIN_ROUTES } from '@efficiently/client-core-routing';

export function resolveLoginPath(url: string): string {
	const clientPortalPrefix = `/${APP_ROUTES.CLIENT_APP_PORTAL.path}/`;

	if (url.startsWith(clientPortalPrefix)) {
		return `/${APP_ROUTES.REQUEST_ACCESS_PORTAL.path}`;
	}
	return OTP_LOGIN_ROUTES.ROOT.fullPath();
}
